// extracted by mini-css-extract-plugin
module.exports = {"root":"StyleGuideV2-module__root__2dggp"};